import { render, staticRenderFns } from "./search-contact-imports.vue?vue&type=template&id=122d6fa7&scoped=true&"
import script from "./search-contact-imports.vue?vue&type=script&lang=js&"
export * from "./search-contact-imports.vue?vue&type=script&lang=js&"
import style0 from "./search-contact-imports.vue?vue&type=style&index=0&id=122d6fa7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122d6fa7",
  null
  
)

export default component.exports